import { useState, useEffect } from 'react';

const MOBILE_BREAKPOINT = 767; // Below Tailwind's md (768px)

/**
 * One-shot read of the mobile breakpoint, for imperative callers that only
 * need the current value (state initializers, ReactFlow onInit) rather than
 * the reactive `useMobile` subscription. Keeps the breakpoint in one place.
 */
export function isMobileViewport(): boolean {
  return typeof window !== 'undefined'
    ? window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT}px)`).matches
    : false;
}

export function useMobile(): boolean {
  const [isMobile, setIsMobile] = useState(isMobileViewport);

  useEffect(() => {
    const mql = window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT}px)`);
    const onChange = (e: MediaQueryListEvent) => setIsMobile(e.matches);
    mql.addEventListener('change', onChange);
    return () => mql.removeEventListener('change', onChange);
  }, []);

  return isMobile;
}
